module.exports = __webpack_public_path__ + "static/media/edinburgh-1.0ce04d15.jpg";